<template lang="pug">
  v-app#app(v-cloak, :light="isLight", :dark="isDark" :class="[applicationClasses, $i18n.locale]")
    v-toolbar#app-header(app flat height=56, color="grey darken-4")
      div.ml-0(@click="toHome")
        img.hidden-xs-only.mx-3(:src="logo" style="height: 55px;")
        img.hidden-sm-and-up.mx-3(:src="icon" style="height: 55px;")
      v-tooltip(v-if="menu.enabled" bottom)
        v-btn(flat icon color="white" @click="menu.drawer = true" slot="activator")
          v-icon menu
        span {{$t('menu')}}
      v-tooltip(bottom)
        v-btn.hidden-xs-only(flat icon color="white" @click="toHome" v-if="isMeLoaded" slot="activator")
          v-icon home
        span {{$t('home')}}
      v-spacer
      v-tooltip(bottom)
        v-btn(flat icon color="white" @click="forceRefresh" v-if="isMeLoaded" slot="activator")
          v-icon refresh
        span {{$t('force_refresh')}}

      v-menu(
        v-if="isMeLoaded"
        offset-y
        left
        bottom
        lazy
        nudge-bottom="5"
        min-width="280"
        content-class="profile-menu"
        :close-on-content-click="false"
      )
        v-btn.px-1(flat color="transparent" slot="activator")
          v-icon.white--text account_circle
          span.pl-2.rem8.white--text {{me.name}}
          v-icon.white--text arrow_drop_down

        v-list.pa-0(dense)
          v-list-tile(v-for="profile, index in profiles", :key="index")
            v-list-tile-avatar
              v-icon {{profile.icon}}
            v-list-tile-content.rem9 {{profile.value}}

          v-divider
          v-list-tile(@click="signOut")
            v-list-tile-avatar
              v-icon exit_to_app
            v-list-tile-content {{$t('_account.signout')}}

      v-menu(
        offset-y
        left
        bottom
        lazy
        nudge-bottom="5"
        min-width="280"
        content-class="profile-menu"
        :close-on-content-click="false"
        class="mr-3"
        v-if="isAuthRequired"
      )
        v-btn(flat icon color="transparent" slot="activator")
          v-icon.grey--text power_settings_new

        v-list.pa-0(dense)
          v-list-tile(@click="forceSignOut")
            v-list-tile-avatar
              v-icon exit_to_app
            v-list-tile-content {{$t('_account.force_signout')}}

    v-navigation-drawer#app-menus(app temporary v-model="menu.drawer")
      v-toolbar(flat height=56, color="grey darken-4")
        img.hidden-xs-only.mx-3(:src="logo" style="height: 40px;")
        img.hidden-sm-and-up.mx-3(:src="icon" style="height: 40px;")

      v-list.pa-0(dense)
        v-list-group(
          v-for="menu in menus"
          :value="menu.active"
          :key="menu.title"
          :prepend-icon="menu.icon"
          v-if="hasRole(menu.role)"
          no-action
        )
          v-list-tile(slot="activator")
            v-list-tile-content
              v-list-tile-title {{menu.title}}
          v-list-tile(
            v-for="child in menu.children"
            :key="child.title"
            ripple
            :to="{name: child.to}"
            v-if="hasRole(menu.role)"
          )
            v-list-tile-content
              v-list-tile-title {{child.title}}
            v-list-tile-action
              v-icon {{child.icon}}

    v-content(style="padding-bottom: 30px;")
      v-container#app-contents(fluid grid-list-sm)
        transition(name="page-fade" mode="out-in")
          router-view

    v-footer#app-footer.hidden-xs-only(app height=25)
      p.space.primary &nbsp;
      p.slash &nbsp;
      p.copyright
        i.fa.fa-fw.fa-copyright
        span {{copyright.year}} {{copyright.company}}

    transition(name="fade" v-if="isLoading")
      div#app-loading
        div.app-loading-wrapper
          div.app-loading-container
            i.fa.fa-fw.fa-spinner.fa-pulse.refresh-animate.primary--text
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CommonMenus from '@/common/menus.js'
import PageMenus from '@/app/menus.js'
import _ from 'underscore'

export default {
  name: 'app-layout-default',
  data () {
    return {
      menu: {
        drawer: false,
        enabled: process.env.APP_MENU_ENABLED
      },
      menus: [],
      copyright: {
        year: process.env.APP_COPYRIGHT_YEAR,
        company: process.env.APP_COPYRIGHT_COMPANY
      }
    }
  },
  created () {
    this.reloadMenus()
  },
  watch: {
    '$i18n.locale': function (v) {
      this.reloadMenus()
    }
  },
  computed: {
    ...mapGetters(`common/${process.env.AUTH_STORATEGY}`, [
      'isMeLoaded',
      'me',
      'hasRole'
    ]),
    ...mapGetters('common/loading', ['isLoading']),
    ...mapGetters('common/theme', ['theme', 'isDark', 'isLight']),
    applicationClasses () {
      const meta = this.$route.meta
      if (!meta) {
        return ''
      }
      const clazz = meta.applicationClasses
      if (!clazz) {
        return ''
      }
      return clazz.join(' ')
    },
    logo () {
      return process.env.APP_LOGO
    },
    icon () {
      return process.env.APP_ICON
    },
    isAuthRequired () {
      return !!this.$route.meta.requiresAuth
    },
    profiles () {
      return [
        {
          icon: 'explore',
          value: this.me.app
        },
        {
          icon: 'security',
          value: this.me.biz
        },
        {
          icon: 'vpn_key',
          value: this.me.code
        },
        {
          icon: 'mail',
          value: this.me.mail
        },
        {
          icon: 'translate',
          value: this.me.language
        },
        {
          icon: 'location_on',
          value: this.me.locale
        },
        {
          icon: 'language',
          value: this.me.timezone
        }
      ]
    }
  },
  methods: {
    ...mapActions(`common/${process.env.AUTH_STORATEGY}`, [
      'signOut',
      'forceSignOut'
    ]),
    toHome () {
      const lang = this.$route.params.lang
      if (lang) {
        this.$router.push(`/${lang}/staff/dashboard`)
      } else {
        this.$router.push('/staff/dashboard')
      }
    },
    forceRefresh () {
      location.href = location.href
    },
    reloadMenus () {
      this.menus = _.sortBy(
        CommonMenus.resolve(this).concat(PageMenus.resolve(this)),
        'displayOrder'
      )
    }
  }
}
</script>

<style scoped lang="stylus">
@import '../../../node_modules/vuetify/src/stylus/settings/_theme';

.page-fade-enter-active, .page-fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.1s;
}

.page-fade-enter-active {
  transition-delay: 0.2s;
}

.page-fade-enter, .page-fade-leave-to {
  opacity: 0;
}

#app-footer {
  &:after {
    content: '';
    position: fixed;
    bottom: 25px;
    width: 100%;
    height: 5px;
  }

  min-height: 25px;

  .space {
    flex-basis: auto;
    height: 100%;
    flex-grow: 1;
  }

  .slash {
    flex-basis: 17px;
    border-top-left-radius: 17px;
    height: 200%;
    margin: -10px;
    transform: rotate(40deg);
  }

  .copyright {
    flex-basis: 320px;
    height: 100%;
    text-align: right;
    margin-right: 0.5rem;
    font-size: 0.9rem;
    margin-top: 0.2rem;
  }
}

.application.theme--light {
  #app-footer {
    background-color: rgba($material-light.text-color, $material-light.secondary-text-percent);
    color: rgba($material-dark.text-color, $material-dark.secondary-text-percent);

    .divider {
      background-color: $body-bg-light;
    }

    .slash {
      background-color: $body-bg-light;
    }

    &:after {
      background-color: $body-bg-light;
    }
  }
}

.application.theme--dark {
  #app-footer {
    background-color: rgba($material-dark.text-color, $material-dark.secondary-text-percent);
    color: rgba($material-light.text-color, $material-light.secondary-text-percent);

    .divider {
      background-color: $body-bg-dark;
    }

    .slash {
      background-color: $body-bg-dark;
    }

    &:after {
      background-color: $body-bg-dark;
    }
  }
}

#app-loading {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.1s ease;

  .app-loading-wrapper {
    height: 100%;
    padding: 0px;
    margin: 0px;
    display: flex;
    align-items: center;

    .app-loading-container {
      width: 180px;
      padding: 10px;
      margin: auto;
      background-color: transparent;
      box-shadow: none;
      border: none;
      transition: all 0.1s ease;

      .refresh-animate {
        font-size: 10rem;
      }
    }
  }
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.application.theme--light {
  #app-loading {
    background-color: rgba(0, 0, 0, 0.2);
  }
}

.application.theme--dark {
  #app-loading {
    background-color: rgba(255, 255, 255, 0.2);
  }
}
</style>



// WEBPACK FOOTER //
// src/common/layouts/Default.vue